export const EMPTY_ASSEMBLY = {
  scheduledDate: '', startTime: '', endTime: '',
  address: '', colonia: '', postalCode: '',
  references: '', lat: '', lng: '',
};

export const EMPTY_REPORT = {
  actualDate: '', actualStartTime: '', actualEndTime: '',
  attendeesCount: 0, objective: '', activitiesPerformed: '',
  observations: '', agreements: '', incidents: '', pendingTasks: '',
};

export const EMPTY_LOGIN = { emailOrIneKey: '', password: '' };

export const EMPTY_NEWSPAPER_ADDRESS = {
  stateId: '',
  state: '',
  federalDistrict: '',
  contactName: '',
  postalCode: '',
  phone1: '',
  phone2: '',
  municipalityId: '',
  municipality: '',
  colonia: '',
  street: '',
  numberExt: '',
  numberInt: '',
  city: '',
  betweenStreet1: '',
  betweenStreet2: '',
  reference: '',
  deliveryInstructions: ''
};

export const EMPTY_NEWSPAPER_REQUEST = {
  addressId: '',
  quantity: 1
};

export const EMPTY_REG = {
  ineKey: '', curp: '', firstName: '',
  lastNamePaternal: '', lastNameMaternal: '',
  phone: '', federalDistrict: '', stateId: '', municipalityId: '', state: '', municipality: '',
  email: '', password: '', confirmPassword: '',
  hasCee: false, cee: '',
};
